// @ts-nocheck
/**
 * pluginName: The plugin namespace, ie for $('.selector').myPluginName(options)
 * Also the id for storing the object state via $('.selector').data()
 */
const pluginName = "pad";
const diffMP = new diff_match_patch();

// make plugin semi-independent from pp functions
let log = console.log;
let debugLog = console.log;
let addPageChangeListener = (elem) => {}; // void
let removePageChangeListener = (elem) => {}; // void
const blankOwnTagOption =
	"<option data-select2-tag='true'>FILLED FROM JS</option>";

// default settings
const defaultOptions = {
	fayeUpdateFreq: 100,
	railsUpdateFreq: 3000,
	targetFocusInEvents: ["focusin", "select2:open"],
	targetFocusOutEvents: ["focusout", "select2:close"],
	listenOnly: false,
	dontUpdateRails: false,
};

/**
 * NB this was used in the mod area before Augsut 2023, the DOM elements that this JS refers to don't exist atm
 */
class DisplayActivityToMods {
	// NB all we need is a getter here, because the getter returns the fill object which can then be written to direct by the calling function
	static get activeSubscribersData() {
		// log("into get activeSubscribersData", this);
		if (this._activeSubscribersData === undefined) {
			this._activeSubscribersData = {};
		}
		return this._activeSubscribersData;
	}

	static get gracetime() {
		return 3000;
	}

	static show(base, elemIndex, editingActorId) {
		log(
			"PAD DisplayActivityToMods show -- editingActorId",
			base,
			editingActorId,
		);
		if (pp.currentActorId !== undefined && editingActorId != base.actorId) {
			// postpone hiding the pencil
			if (
				this.activeSubscribersData[base.options.displayActivityForUserId] !==
				undefined
			) {
				clearTimeout(
					this.activeSubscribersData[base.options.displayActivityForUserId]
						.timeout,
				);
			}

			// find correct phase's actor tasks and show the pulsating pencil icon
			base.targets[elemIndex].elem
				.closest("div.reading-mode-content")
				.siblings("div.menu")
				.find(`span.j-editing-user-${base.options.displayActivityForUserId}`)
				.show();
			base.targets[elemIndex].elem
				.closest("div.content-inner")
				.find(`span.j-editing-actor-${editingActorId}`)
				.show();

			// Set timeout to hide the pencil icon again and provide data in the hash
			// NB the displayActivityForUserId keys in the hash don't actually differentiate between different phases' tasks, but assume that the user will either not
			// work on tasks of other phases, or at least take 3000ms before working on another task in another phase
			this.activeSubscribersData[base.options.displayActivityForUserId] = {
				timeout: setTimeout(() => {
					DisplayActivityToMods.hide(base); // `this` is the window object here, so use `base`
				}, this.gracetime),
				elemIndex: elemIndex,
				editingActorId: editingActorId,
			};
			log(
				"PAD mod activity notification added:",
				this.activeSubscribersData[base.options.displayActivityForUserId],
				base.targets[elemIndex].elem
					.closest("div.reading-mode-content")
					.siblings("div.menu")
					.find(`span.j-editing-user-${base.options.displayActivityForUserId}`),
			);
		}
	}

	static hide(base) {
		log(
			"PAD activity hiding -- pad url, editing user id:",
			base.options.url,
			base.options.displayActivityForUserId,
		);
		const elemIndex =
			this.activeSubscribersData[base.options.displayActivityForUserId]
				.elemIndex;
		base.targets[elemIndex].elem
			.closest("div.reading-mode-content")
			.siblings("div.menu")
			.find(`span.j-editing-user-${base.options.displayActivityForUserId}`)
			.hide();
		base.targets[elemIndex].elem
			.closest("div.content-inner")
			.find(
				`span.j-editing-actor-${this.activeSubscribersData[base.options.displayActivityForUserId].editingActorId}`,
			)
			.hide();
		// a timeout might still be present if this is called from the clearData function
		clearTimeout(
			this.activeSubscribersData[base.options.displayActivityForUserId].timeout,
		);
		delete this.activeSubscribersData[base.options.displayActivityForUserId];
	}
}

export default class {
	/****************************************************
	 * To init, call
	 * $('selector').pad(options)
	 *
	 * Some time later...
	 * $('selector').pad('myActionMethod')
	 *
	 * DETAILS:
	 * Once inited with $('...').pad(options), you can call
	 * $('...').pad('myAction') where myAction is a method in this
	 * class.
	 * Methods which begin with underscore are private and not
	 * publically accessible.
	 * The only public method is clearData at the moment.
	 */
	constructor(targetElems, options) {
		log("PAD init -- targetElems, options", targetElems, options);

		// To avoid scope issues, use 'base' instead of 'this' to reference this class from internal events
		const base = this;
		base.options = $.extend({}, defaultOptions, options);
		// Generate random positive integer, this will only be good for one session
		if (base.options.actorId) {
			base.actorId = base.options.actorId;
		} else {
			base.actorId =
				typeof pp != "undefined" && pp.currentActorId !== undefined
					? pp.currentActorId
					: Math.floor(Math.random() * (9999999999 - 1000000000)) + 1000000000;
		}
		base.actorColor =
			typeof pp != "undefined" ? pp.viewHelpers.getRandomColor() : "#000";
		base.targets = [];
		base.pendingRailsSyncIndices = [];
		base.fayeSubscriptionCallbacks = [base._notifyOwnSubscription];
		base.activeSubscribers = [];
		base.inputFieldsState = {
			enabled: true,
			printLog: false,
		};

		base.observeChange(
			"inputFieldsState",
			base,
			base._handleInputFieldStateChange,
		);
		if (base.options.subscribersSpanSelector) {
			base.$subscribersSpan = $(base.options.subscribersSpanSelector);
			if (base.$subscribersSpan.length) {
				base.observeChange(
					"activeSubscribers",
					base,
					base._updateActiveSubscribersSpan,
				);
			} else {
				console.warn(
					"Subscribers span selector on Pad provided but no element found -- selector, pad elems:",
					base.options.subscribersSpanSelector,
					targetElems,
				);
			}
		}

		// determine the function with which the value is being read and set and push the states of all the targets
		$.each(targetElems, (index, elem) => {
			const newTarget = {
				elem: $(elem),
				needsStringifyFunction: false, // default
				setValueCallbacks: [],
				setCursorPositionHandler: getInputSelection, // Always store this to keep consistent indices on the array, even if it will never be called if `lsitenOnly` is `false`
				updateCursorPositionHandler: base._updateCursorPositionData,
			};

			switch (elem.tagName) {
				case "SELECT":
					newTarget.setValue = (string) => {
						// Test if "tagging" is allowed for this select2 element, i.e. users can insert their own options, and if so and if
						// the incoming option is not present, create the `<option>` element for it
						if (newTarget.elem.data("tag") !== undefined) {
							const presentOptionIndex = _.findIndex(
								$(elem).children(),
								(optionElem) => {
									return optionElem.text == string;
								},
							);
							if (presentOptionIndex == -1) {
								const $newTagOption = $(blankOwnTagOption);
								$newTagOption.attr("value", string).html(string);
								$(elem).append($newTagOption);
							}
						}
						$(elem).val(string);
					};
					newTarget.getValueFunctionName = "val";
					if (elem.multiple) {
						// == true
						newTarget.needsStringifyFunction = true;
					}
					break;

				case "TEXTAREA":
					newTarget.setValue = (string) => {
						$(elem).val(string);
					};
					newTarget.getValueFunctionName = "val";
					break;

				case "INPUT":
					newTarget.setValue = (string) => {
						$(elem).val(string);
					};
					newTarget.getValueFunctionName = "val";
					break;

				default: // For contenteditables
					newTarget.setValue = (string) => {
						$(elem).html(string);
					};
					newTarget.getValueFunctionName = "html";
					break;
			}

			newTarget.getValue = () => {
				return newTarget.elem[newTarget.getValueFunctionName]();
			};
			newTarget.setValueWrapper = (string) => {
				newTarget.setValueCallbacks.forEach((callback, index) => {
					callback(string);
				});
				return newTarget.setValue(string);
			};

			if (base.options.states === undefined) {
				// Set up fake states
				newTarget["state"] = new State(
					new window.Buffer([
						{
							user: 0,
							text: elem.multiple ? [] : newTarget.getValue(),
						},
					]),
					{
						0: 1,
					},
				);
				newTarget["lastRailsText"] = "";
				debugLog(
					"PAD generated fake state -- buffer, vector:",
					newTarget["state"].buffer,
					newTarget["state"].vector,
				);
			} else {
				newTarget["state"] = base.options.states[index];
				newTarget["lastRailsText"] =
					base.options.states[index].buffer.toString();
			}
			base.targets.push(newTarget);

			base.activeSubscribers.push({});

			if (base.options.listenOnly) {
				return; // Don't add the listeners
			}
			newTarget.elem
				.on(base.options.targetFocusInEvents.join(" "), (event) => {
					// focusin for textareas and contenteditables, select2 for jq plugin
					base._notifyActivity(event.type, index);
					// check if the vector of that target only consists of the fake vector built from the buffer template
					if (
						base.targets[index].elem.attr("data-template-text") !== undefined &&
						base.targets[index].elem.attr("data-template-text") ==
							base.targets[index].getValue()
					) {
						base._initFakePlaceholderListener(index);
					}
				})
				.on(base.options.targetFocusOutEvents.join(" "), (event) => {
					base._notifyActivity(event.type, index);
				});
		});

		// Listen for click on send button and call clearData() to send the latest version to the server.
		// (only if anything has ever happened in the Pad)
		if (base.options.clearDataButtonSelector !== undefined) {
			$(base.options.clearDataButtonSelector).data(
				"wasInitiallyDisabled",
				$(base.options.clearDataButtonSelector).prop("disabled"),
			);
			base._listenForClearDataButtonClick(targetElems);
		}

		if (
			base.options.persistenceStatusSelector !== undefined &&
			$(base.options.persistenceStatusSelector).length == 0
		) {
			console.warn(
				"Persistence status selector on Pad provided but no element found -- selector, pad elems:",
				base.options.persistenceStatusSelector,
				targetElems,
			);
		}

		// only listen for stuff to push if listenOnly isn't true
		if (!base.options.listenOnly) {
			base._setupChangeListeners();
			// disable this Pad's input fields now and wait for the right Faye channel to subscribe
			base.inputFieldsState = {
				enabled: false,
				printLog: false,
			};
		}
		$(document).on(
			"senaryon:subscribedFayeChannel",
			base,
			base._handleFayeSubscriptionEvent,
		);

		// custom subscribe with callback
		PrivatePub.subscribe(base.options.url, (data, channel) => {
			base._handleIncomingData(data);
		});

		// Assume that all other input fields will be destroyed as well, but only trigger this once
		$(targetElems[0]).one(
			"destroyed destroyed_proxy",
			base,
			base._handledDestroyedElem,
		);

		// deletegate data clearing by page:before-change to named method
		$(document).one("page:before-change", base, base._handlePageBeforeChange);

		PrivatePub.observeChange("state", base, base._observePrivatePubChanges);

		base.observeChange(
			"pendingRailsSyncIndices",
			base,
			(oldval, newval, base) => {
				if (newval.length) {
					base._setPersistenceStatus(1);

					if (!base.updateRailsTimeout) {
						base.updateRailsTimeout = setTimeout(
							base._updateRails,
							base.options.railsUpdateFreq,
							base,
						);
					}
				} else {
					base._setPersistenceStatus(0);
					base.updateRailsTimeout = null;
				}
			},
		);

		base.initializedAt = new Date().toLocaleString();

		delete base.options.states;

		// Only for the logs
		let targetElemIds = [];
		$.each(targetElems, (index, elem) => {
			targetElemIds.push($(elem).attr("id"));
		});
		// force a printout of the pad object in the log buffer, not a reference
		log(
			"PAD newly initialized -- target elem ids, options:",
			targetElemIds,
			JSON.stringify(base.options),
		);
	}

	_setupChangeListeners() {
		const base = this;

		// update own state with textarea
		base.targets.forEach((target, index) => {
			if (target.elem.prop("contenteditable") == "true") {
				target.elem
					.on("input", (event) => {
						if (
							event.inputType == "insertParagraph" ||
							event.originalEvent.inputType == "insertParagraph"
						) {
							const lastChildNode =
								event.currentTarget.childNodes[
									event.currentTarget.childNodes.length - 1
								];
							if (lastChildNode.tagName != "BR") {
								return;
							}
							lastChildNode.outerHTML = " "; // Replace with a space
						}
					})
					.on("paste", () => {
						// Can't allow pasting content because the formatting of the pasted text
						// is preserved, i.e. it would be possible to paste headlines, highlighted text etc.
						return false;
					});
			}

			target.elem.on("input", (event) => {
				if (!base.updateFayeTimeout) {
					base.updateFayeTimeout = setTimeout(
						base._checkStatesForFaye,
						base.options.fayeUpdateFreq,
						base,
					);
				} else {
					debugLog("PAD updateFayeTimeout already present");
				}
			});
		});
	}

	_listenForClearDataButtonClick(targetElems) {
		const base = this;
		const $clearDataButton = $(base.options.clearDataButtonSelector);
		// log("PAD clear data button obj:", $clearDataButton);
		if (!$clearDataButton.length) {
			console.warn(
				"Clear data button selector on Pad provided but no element found -- selector, pad elems:",
				base.options.clearDataButtonSelector,
				targetElems,
			);
		}
		$clearDataButton.data("clearDataButtonFor", targetElems);
		$clearDataButton.one("click", (event) => {
			const unequalIndicesforRails = base._checkStatesForRails();
			log(
				"PAD clearDataButton clicked, unsaved data present:",
				unequalIndicesforRails,
			);
			if (unequalIndicesforRails.length) {
				// Do this to trigger updating the target states one last time
				for (let i = 0; i < unequalIndicesforRails.length; i++) {
					base._updateState({
						index: unequalIndicesforRails[i],
					});
				}
				base.clearData();
				PrivatePub.deleteNonFeed(base.options.url, "clearDataButton clicked");
			}
		});
	}

	_checkStatesForFaye(base = this) {
		if (PrivatePub.state != PrivatePub.CONNECTED) {
			// log("PAD not executing _checkStatesForFaye, PrivatePub is not connected");
			base.updateFayeTimeout = null;
			return;
		}
		base.targets.forEach((target, index) => {
			if (!base._valNotEqualTo(index, target.state.buffer.toString())) {
				return; // Nothing to do
			}
			// log("PAD checkStatesForFaye trigger -- index, buffer string, input value", index, target.state.buffer.toString(), target.getValue());
			// Add a page change confirm for this field. It will be released once Rails is updated (from `_checkStatesForRails` function below).
			// Don't do this if there is no Rails endpoint, nothing could be saved anywhere then.
			// Also don't add the page change listener if the input value is empty. Rails will still get updated, but there is no promt the user to confirm
			// a page change if there is not text that would be lost
			if (!target.getValue().length && target.elem.attr("data-template-text")) {
				target.setValueWrapper(target.elem.attr("data-template-text"));
				target.elem.addClass("text-gap-draft-whitespaces--showing-placeholder");
				base._initFakePlaceholderListener(index);
			}
			if (
				!target.elem.hasClass("j-watched-for-page-change") &&
				!base.options.dontUpdateRails &&
				target.getValue() != ""
			) {
				log("PAD adding to pp.pageChangeConfirm", target.elem);
				addPageChangeListener(target.elem);
			}
			if (!base.options.dontUpdateRails) {
				// Need to clone and then manipulate the array so that upon assigning a wholly new variable the observer will be called
				const pendingRailsSyncIndicesClone = Object.assign(
					[],
					base.pendingRailsSyncIndices,
				);
				pendingRailsSyncIndicesClone.push(index);
				base.pendingRailsSyncIndices = pendingRailsSyncIndicesClone;
			}
			base._updateState({ index: index });
		});
		base.updateFayeTimeout = null;
	}

	_checkStatesForRails() {
		if (PrivatePub.state != PrivatePub.CONNECTED) {
			// log("PAD not executing _checkStatesForRails, PrivatePub is not connected");
			return [];
		}
		const unequalIndices = [];
		this.targets.forEach((target, index) => {
			if (!this._valNotEqualTo(index, target.lastRailsText)) {
				return; // Nothing to do
			}
			unequalIndices.push(index);
		}, this);

		return unequalIndices;
	}

	/**
	 * compare the target's value with the given compareString (either the pad's buffered string or its lastRailsText)
	 */
	_valNotEqualTo(index, compareString) {
		const stringTargetVal = this._parseTargetValue(index);
		// if (stringTargetVal.localeCompare(compareString) != 0) {
		// 	log("PAD detected unequal values on:", this.targets[index], compareString, "new:", stringTargetVal);
		// }
		if (stringTargetVal === null) {
			return false;
		}

		return stringTargetVal.localeCompare(compareString) != 0;
	}

	/**
	 * read the target element's value and decide how to parse it so that it can be compared with the state's buffered value
	 */
	_parseTargetValue(index) {
		try {
			if (this.targets[index].needsStringifyFunction) {
				// select returns ´null´ when nothing is selected (rather than an empty array),
				// and select.toString() returns a concatenated string of the values without the ´[]´, so use JSON.stringify
				if (this.targets[index].getValue() == null) {
					return "[]";
				} else {
					const valueArray = this.targets[index].getValue();
					if (valueArray instanceof Array) {
						return JSON.stringify(valueArray);
					} else {
						throw new SyntaxError(
							"Read value from target is not an array, but should be, because target needs stringify function.",
						);
					}
				}
			} else {
				return this.targets[index].getValue();
			}
		} catch (exception) {
			log(
				"PAD valNotEqualTo error -- exception, target:",
				exception,
				this.targets[index].elem,
			);
			this._handleError("valNotEqualTo error: " + exception.toString());
		}
	}

	_parseJSONof(string) {
		try {
			return JSON.parse(string);
		} catch (exception) {
			log("PAD parseJSONof error -- error obj, string:", exception, string);
			this._handleError(
				"parseJSONof error: " + exception.toString() + ", string: " + string,
			);
		}
	}

	/**
	 * decide what to do with the incoming data from the resp. channel
	 * @param {Object} data hash with the information
	 */
	_handleIncomingData(data) {
		// log("PAD incoming -- own url, data:", this.options.url, data);

		switch (data.type) {
			case "publish":
				if (data.actorId == this.actorId) {
					const foreignVector = new window.Vector(data.vector);
					debugLog(
						"PAD checking for self update -- actorId, own vector, foreign vector:",
						this.actorId,
						this.targets[data.index].state.vector,
						foreignVector,
					);
					if (
						foreignVector[this.actorId] === undefined ||
						this.targets[data.index].state.vector[this.actorId] - 1 >=
							foreignVector[this.actorId]
					) {
						debugLog(
							"PAD incoming vector from same user, and pad state already updated, so no need to do anything",
						);
						return;
					}
				}

				if (!this.options.listenOnly) {
					// remember cursor position
					this.currentSelectionRange = this.targets[
						data.index
					].setCursorPositionHandler(
						this.targets[data.index].elem.get(0),
						this,
					);
				} else if (this.options.displayActivityForUserId !== undefined) {
					DisplayActivityToMods.show(this, data.index, data.actorId);
				}

				const newStateBuffer = this._updateState(data);
				const target = this.targets[data.index];
				target.setValueWrapper(newStateBuffer); // overwrite pad target's value with new Buffer
				// log("OVERWRITNG last rails text -- before, after", this.targets[data.index].lastRailsText, this._parseTargetValue(data.index));
				this.targets[data.index].lastRailsText = this._parseTargetValue(
					data.index,
				);
				// check if currentSelectionRange is still there (might be removed if something was changed just inside of the selection)
				if (this.currentSelectionRange != undefined) {
					setInputSelection(
						target.elem.get(0),
						this.currentSelectionRange.start,
						this.currentSelectionRange.end,
					);
				}
				// manually trigger the listener from pp.maxChars if there is one and update the select2 boxes (if this is a select element)
				target.elem.trigger("change");
				break;

			case "notifyActivity":
				if (this.options.listenOnly || data.actorId == this.actorId) {
					return;
				}

				if (this.options.targetFocusInEvents.indexOf(data.eventType) != -1) {
					debugLog("PAD notifyActivity in", this.targets[data.index].elem);
					this.targets[data.index].elem.addClass("focused"); // only has an effect on textareas
					this._updateActiveSubscribers("add", data);
				} else {
					debugLog("PAD notifyActivity out", this.targets[data.index].elem);
					this.targets[data.index].elem.removeClass("focused");
					this._updateActiveSubscribers("remove", data);
				}
				break;

			case "tinyMCENodeChange":
				if (data.actorId == this.actorId) {
					return;
				}
				this._updateActiveSubscribers("add", data);
				break;

			case "subscribed":
				if (this.options.listenOnly || data.actorId == this.actorId) {
					return;
				}

				this.targets.forEach((target, index) => {
					// check if any elements do currently have focus and inform the new subscriber
					if (target.elem.is(":focus")) {
						this._notifyActivity("focusin", index);
					}
					// check if the remote pad is already out of date (due to loading times and recent activity in this pad)
					if (target.state.vector.toString() != data.currentVectors[index]) {
						this._overwriteOtherPad(
							data.actorId,
							index,
							target.state.vector.toString(),
							target.state.buffer.toString(),
						);
					}
				}, this);
				break;

			case "unsubscribed":
				if (this.options.listenOnly || data.actorId == this.actorId) {
					return;
				}

				debugLog(
					"PAD unsubscribed -- own url, sending actorId:",
					this.options.url,
					data.actorId,
				);
				this._updateActiveSubscribers("remove", data); // No index here
				break;

			case "overwriteOtherPad":
				if (data.actorId == this.actorId || data.forActorId != this.actorId) {
					return;
				}
				log("PAD _OVERWRITING_ own data from remote -- data:", data);

				if (this.targets[data.index].needsStringifyFunction) {
					data.bufferString = this._parseJSONof(data.bufferString);
				}
				const newBuffer = new window.Buffer([
					{
						user: this.actorId,
						text: data.bufferString,
					},
				]);
				const newVector = new window.Vector(data.vector);
				this.targets[data.index].state = new State(newBuffer, newVector);

				let overwriteValue;
				if (this.targets[data.index].needsStringifyFunction) {
					overwriteValue = this._parseJSONof(
						this.targets[data.index].state.buffer.toString(),
					);
				} else {
					overwriteValue = this.targets[data.index].state.buffer.toString();
				}
				// log("PAD overwriteValue:", overwriteValue);
				this.targets[data.index].setValueWrapper(overwriteValue);
				this.targets[data.index].elem.trigger("change");

				break;
		}
	}

	/**
	 * core function, updates state of the pad target with the given index
	 * can be called both from the PrivatePub listener or from the interval for self-updates, then determines which variables to use and updates state vector and buffer
	 * preserves cursor position or text selection
	 * @param {Object} args Hash or arguments, either only contains :index of in the this.targets array or vector, differences array and sending actorId when called from the Private Pub listener
	 */
	_updateState(args = {}) {
		log("PAD updateState -- pad url, args:", this.options.url, args);

		const currentIndex = args.index;
		const currentTarget = this.targets[currentIndex];
		let currentDiffArr;
		let currentVector;
		let currentActorId;
		if (args.type === undefined) {
			// Must be self update
			log("PAD updateState -- update self, then publish to Faye");

			const currentTargetValue = currentTarget.getValue();

			if (currentTarget.needsStringifyFunction) {
				// log("PAD updateState before diff, old string", currentTarget.state.buffer.toString());
				// log("PAD updateState old parsed", this._parseJSONof(currentTarget.state.buffer.toString()), "new", currentTargetValue);
				currentDiffArr = this._getArrayDiffArray(
					this._parseJSONof(currentTarget.state.buffer.toString()),
					currentTargetValue,
				);
			} else {
				// log("before diff, old", currentTarget.state.buffer.toString(), "new", currentTargetValue);
				currentDiffArr = diffMP.diff_main(
					currentTarget.state.buffer.toString(),
					currentTargetValue,
				);
				diffMP.diff_cleanupSemantic(currentDiffArr);
			}
			currentVector = currentTarget.state.vector;
			currentActorId = this.actorId;

			this._publish(
				currentIndex,
				currentDiffArr,
				currentTarget.state.vector.toString(),
			);
		} else {
			// Comes from outside
			// Check if own pad has been changed in the meantime, update self first then
			if (
				!this.options.listenOnly &&
				this._valNotEqualTo(currentIndex, currentTarget.state.buffer.toString())
			) {
				log(
					"PAD updateState found pending object -- update self first with:",
					currentTarget,
				);
				// Update self with own changes first
				this._updateState({ index: currentIndex });
			}

			// manually trigger the autosize
			currentTarget.elem.trigger("input.autosize");

			// proceed with update from outside
			currentDiffArr = args.diffArr;
			currentVector = args.vector;
			currentActorId = args.actorId;
		}

		if (
			!this._processDiffArray(
				currentTarget,
				currentDiffArr,
				currentVector,
				currentActorId,
			)
		) {
			log("PAD updateState update not successful");
		}

		// log("PAD updateState new buffer string for target -- index, string length:",
		// 	currentIndex, currentTarget.state.buffer.toString().length);

		if (currentTarget.needsStringifyFunction) {
			return this._parseJSONof(currentTarget.state.buffer.toString());
		} else {
			return currentTarget.state.buffer.toString();
		}
	}

	/**
	 * apply all computed changes to the target's state
	 */
	_processDiffArray(
		currentTarget,
		currentDiffArr,
		currentVector,
		currentActorId,
	) {
		// log("PAD _processDiffArray -- currentDiffArr, currentVector, currentTarget: ", currentDiffArr, currentVector, currentTarget);

		const base = this;
		let processedText = currentTarget.needsStringifyFunction ? [] : ""; // Needs to be an array because it will contain arrays with one item each, where the item is the resp. content of the select element
		$(currentDiffArr).each((index, arrayItem) => {
			const changeType = arrayItem[0];
			const changeText = arrayItem[1];

			let operation;
			let request;
			// log("PAD looking at diff elem -- type, text:", changeType, changeText, processedText);
			switch (changeType) {
				case 0: // no changes
					processedText = processedText.concat(changeText);
					break;

				case 1: // insertion
					const segment = new window.Segment(currentActorId, changeText);
					const buffer = new window.Buffer([segment]);
					operation = new window.Operations.Insert(
						processedText.length,
						buffer,
					);
					request = new window.DoRequest(
						currentActorId,
						new window.Vector(currentVector),
						operation,
					);

					// check if this request can be executed or decide what to do otherwise
					if (currentTarget.state.canExecute(request)) {
						currentTarget.state.execute(request);
						currentVector = currentTarget.state.vector; // update vector so that next request's vector is up to date (would be skipped otherwise)
					} else {
						log(
							"PAD processDiffArray can't update state for -- pad url, insert request:",
							base.options.url,
							request,
						);
						return;
					}

					// cursor manipulation
					if (
						base.currentSelectionRange !== undefined &&
						base.actorId != currentActorId
					) {
						currentTarget.updateCursorPositionHandler(
							base,
							changeType,
							processedText,
							changeText,
						);
					}
					processedText = processedText.concat(changeText);
					break;

				case -1: // deletion
					operation = new window.Operations.Delete(
						processedText.length,
						changeText.length,
					);
					request = new window.DoRequest(
						currentActorId,
						new window.Vector(currentVector),
						operation,
					);

					if (currentTarget.state.canExecute(request)) {
						currentTarget.state.execute(request);
						// update vector so that next request's vector won't cause the request do be skipped
						currentVector = currentTarget.state.vector;
					} else {
						log(
							"PAD processDiffArray can't update state for -- pad url, deletion request",
							base.options.url,
							request,
						);
						return;
					}

					// cursor manipulation
					if (
						base.currentSelectionRange !== undefined &&
						base.actorId != currentActorId
					) {
						currentTarget.updateCursorPositionHandler(
							changeType,
							processedText,
							changeText,
						);
					}
					break;
			}
		});

		return true;
	}

	/**
	 * compares two arrays (rather than diff_match_patch which compares strings)
	 * and generates an array that signifies which elements where deleted, unchanged, or inserted from the original
	 */
	_getArrayDiffArray(oldArray, newArray) {
		const diffArr = [];
		newArray = newArray || []; // might be null in case of an empty multiple select box

		// previous buffer was empty, just add all the new values
		if (oldArray.length == 0) {
			for (let index in newArray) {
				diffArr.push([1, [newArray[index]]]);
			}
			return diffArr;
		}

		// compare old and new array
		let insertionOffset = 0;
		let currentBufferVal = undefined;
		let index = 0;
		while (index < oldArray.length) {
			currentBufferVal = oldArray[index];

			if (newArray.indexOf(currentBufferVal) != -1) {
				if (currentBufferVal == newArray[index + insertionOffset]) {
					diffArr.push([0, [currentBufferVal]]);
				} else {
					// detected a gap
					// log("gap:", index + insertionOffset, newArray.indexOf(currentBufferVal));
					while (index + insertionOffset < newArray.indexOf(currentBufferVal)) {
						diffArr.push([1, [newArray[index + insertionOffset]]]);
						insertionOffset++;
					}
					diffArr.push([0, [currentBufferVal]]);
				}
			} else {
				diffArr.push([-1, [currentBufferVal]]); // deleted
				insertionOffset--;
			}
			index++;
		}
		// now add the rest of newArray
		while (insertionOffset + index < newArray.length) {
			// log("adding after length of original has been reached, index, elem:", insertionOffset + index, newArray[insertionOffset + index]);
			diffArr.push([1, [newArray[insertionOffset + index]]]);
			insertionOffset++;
		}
		// log("returning", diffArr);
		return diffArr;
	}

	/**
	 * send array with differences to the channel to trigger an update of the other subscribers
	 * @param {Object} index target number that should get updated at the other end
	 * @param {Object} diffArr differences to last state
	 * @param {Object} vector log of changes
	 */
	_publish(index, diffArr, vector, bufferString) {
		log(
			"PAD publishing to url, diffArr, vector, bufferString:",
			this.options.url,
			diffArr,
			vector,
			bufferString,
		);
		this._sendViaFaye({
			type: "publish",
			actorId: this.actorId,
			index: index,
			diffArr: diffArr,
			vector: vector,
		});
	}

	/**
	 * update (i.e. overwrite) a specific actor's pad that has been found the be outdated
	 */
	_overwriteOtherPad(forActorId, index, vector, bufferString) {
		log(
			"PAD _OVERWRITING_ data of remote pad -- pad url, for actor, vector, buffer string:",
			this.options.url,
			forActorId,
			vector,
			bufferString,
		);
		this._sendViaFaye({
			type: "overwriteOtherPad",
			actorId: this.actorId,
			forActorId: forActorId,
			index: index,
			vector: vector,
			bufferString: bufferString,
		});
	}

	/**
	 * notify the other users of the pad that this one is active
	 */
	_notifyActivity(eventType, index) {
		// log("PAD notifying activity -- eventType: ", eventType);
		this._sendViaFaye({
			type: "notifyActivity",
			index: index,
			actorId: this.actorId,
			eventType: eventType,
		});
	}

	notifyTinyMCENodeChange(index) {
		this.currentSelectionRange = this.targets[index].setCursorPositionHandler(
			this.targets[index].elem.get(0),
			this,
		);
		this._sendViaFaye({
			type: "tinyMCENodeChange",
			index: index,
			actorId: this.actorId,
			actorColor: this.actorColor,
			start: this.currentSelectionRange.start,
			end: this.currentSelectionRange.end,
		});
	}

	_initFakePlaceholderListener(index) {
		log("PAD initFakePlaceholder -- index", index);
		const thisTarget = this.targets[index];
		const that = this;

		// For Chrome: Move to the end of the callstack, so that the `focusNode` will be set
		setTimeout(() => {
			setInputSelection(thisTarget.elem.get(0), 0, 0);
		}, 0);
		thisTarget.elem.one("input", this, this._cutFakePlaceholderOnInput);

		thisTarget.elem.one(this.options.targetFocusOutEvents.join(" "), () => {
			thisTarget.elem.off("input", that._cutFakePlaceholderOnInput);
		});
	}

	_cutFakePlaceholderOnInput(event) {
		const thisPad = event.data;
		let currentTarget = null;
		const that = this;
		thisPad.targets.forEach((target, index) => {
			if (target.elem.get(0) == that) {
				currentTarget = target;
			}
		});
		const overwriteValue = currentTarget
			.getValue()
			.substring(0, window.getSelection().getRangeAt(0).startOffset);
		currentTarget.setValueWrapper(overwriteValue);
		setInputSelection(currentTarget.elem.get(0), overwriteValue.length);
		currentTarget.elem.removeClass(
			"text-gap-draft-whitespaces--showing-placeholder",
		);
	}

	/**
	 * wrap sending via PrivatePub's Faye connection to catch connection loss
	 */
	_sendViaFaye(dataHash) {
		debugLog(
			"PAD sendViaFaye -- pad url, data hash:",
			this.options.url,
			dataHash,
		);
		if (this.failedAt) {
			log("PAD sendViaFaye returning, pad failed");
			return; // only trigger the errors once
		}

		if (
			PrivatePub.fayeClient === null ||
			PrivatePub.fayeClient._dispatcher._state !=
				PrivatePub.fayeClient._dispatcher.UP ||
			PrivatePub.fayeClient._state != PrivatePub.fayeClient.CONNECTED
		) {
			log(
				"PAD not executing sendViaFaye because fayeClient state, dispatcher state",
				PrivatePub.fayeClient
					? (PrivatePub.fayeClient._state || "(no fayeClient state)",
						PrivatePub.fayeClient._dispatcher._state || "(no dispatcher state)")
					: "NO FAYE CLIENT",
			);
			// if a pad target is focused and the user navigates away from the page, the fayeClient will be removed before the pad can send its focusout event.
			// do nothing in this case -- an 'unsubscribed' event will still be sent through the channel
			if (dataHash.type == "notifyActivity") {
				debugLog(
					"PAD omit triggering fail clearData, data type is notifyActivity",
				);
				return;
			}

			this._handleError(
				"Faye client null OR client state, dispatcher state: " +
					(PrivatePub.fayeClient
						? PrivatePub.fayeClient._state +
							", " +
							PrivatePub.fayeClient._dispatcher._state
						: "null"),
			);
		} else {
			const base = this; // Faye publish callbacks also change the scope
			PrivatePub.fayeClient
				.publish(
					this.options.url,
					{
						data: dataHash,
					},
					{
						attempts: 3,
					},
				)
				.then(
					() => {
						// debugLog("PAD message received by Faye server!");
					},
					(error) => {
						log(
							"PAD Faye error while publishing message -- pad url, error message, data:",
							base.options.url,
							error.message,
							dataHash,
						);
						base._handleError(
							"Faye error while publishing message: " + error.message,
						);
					},
				);
		}
	}

	/**
	 * merge data of all pad targets and send them to Rails
	 */
	_updateRails(base = this) {
		if (PrivatePub.state == PrivatePub.DISCONNECTING) {
			log("PAD not updating rails because the client is disconnecting");
			return;
		}

		const railsBufferSegments = [];
		const railsVector = [];
		const railsBufferStrings = [];

		// merge all data
		base.targets.forEach((target, index) => {
			target.lastRailsText = target.state.buffer.toString(); // update last snapshot
			railsBufferSegments.push(target.state.buffer.segments);
			railsVector.push(target.state.vector);
			// the buffer string is already stringified, so conert it back to an array
			if (target.needsStringifyFunction) {
				railsBufferStrings.push(
					base._parseJSONof(target.state.buffer.toString()),
				);
			} else {
				railsBufferStrings.push(target.state.buffer.toString());
			}
		});

		$.ajax({
			url: base.options.url,
			type: "PUT",
			dataType: "json",
			data: {
				buffer_segments: JSON.stringify(railsBufferSegments),
				vector: JSON.stringify(railsVector),
				buffer_string: JSON.stringify(railsBufferStrings),
			},
		})
			.success(() => {
				// Remove all the target elements from the page change listener
				base.targets.forEach((target, index) => {
					removePageChangeListener(target.elem);
				});
				base.pendingRailsSyncIndices = [];
			})
			.error((jqXHR, textStatus, errorThrown) => {
				log(
					"PAD updateRails error -- url, jqXHR, textStatus, errorThrown:",
					base.options.url,
					jqXHR,
					textStatus,
					errorThrown,
				);
				base._handleError(
					"updateRails error for buffer strings: " +
						railsBufferStrings.toString(),
				);
			});
	}

	_updateActiveSubscribers(updateType, data) {
		// Don't do anything if there is no `pp` object (we need the names from the VueStore)
		if (typeof pp === "undefined" || typeof VueStore === "undefined") {
			return;
		}

		const activeSubscribersDup = Object.assign([], this.activeSubscribers);
		// log("PAD _updateActiveSubscribers", updateType, data);

		if (updateType == "add") {
			// Check if that Actor is not present in the activeSubscribers list and update the list
			if (
				typeof VueStore !== "undefined" &&
				VueStore.getters.actorData(data.actorId) === undefined
			) {
				return; // No need to update html
			}
			activeSubscribersDup[data.index][data.actorId] = {
				selectionStart: data.start,
				selectionEnd: data.end,
				selectionColor: data.actorColor,
			};
		} else {
			// = 'remove'
			if (data.index !== undefined) {
				delete activeSubscribersDup[data.index][data.actorId];
			} else {
				// No `index` will be provided in some cases (e.g. when the incoming data type is 'unsubscribed'), so delete the `data.actorId` from all indices
				for (let index = 0; index < activeSubscribersDup.length; index++) {
					delete activeSubscribersDup[index][data.actorId];
				}
			}
		}
		// log("PAD updateActiveSubscribers: ", activeSubscribersDup);
		this.activeSubscribers = activeSubscribersDup;
	}

	_updateActiveSubscribersSpan(oldval, newval, context) {
		// log("PAD updateActiveSubscribersSpan -- display span, activeSubscribers: ", context.$subscribersSpan, newval);
		const namesForSpan = [];

		// Collect all the Actors' names for the $subscribersSpan, no matter which target index they belong to
		newval.forEach((subscriersforIndex, index) => {
			Object.keys(subscriersforIndex).forEach((actorId) => {
				const actorNames = VueStore.getters.actorData(actorId).names;
				namesForSpan.push(
					actorNames[I18n.locale] || Object.values(actorNames)[0],
				);
			});
		});

		if (namesForSpan.length) {
			context.$subscribersSpan.html(
				`<span class='senaryon-icon senaryon-icon-alert' title='${I18n.t("private_pub.pad_subscribers_active")}${namesForSpan.join(", ")}'></span>`,
			);
		} else {
			context.$subscribersSpan.html("");
		}
	}

	_setPersistenceStatus(statusCode) {
		// log("PAD into setPersistenceStatus -- pad, statusCode:", this, statusCode);
		if (this.options.persistenceStatusSelector === undefined) {
			return;
		}

		if (statusCode == 0) {
			$(this.options.persistenceStatusSelector).removeClass("unsaved");
		} else if (statusCode == 1) {
			$(this.options.persistenceStatusSelector).addClass("unsaved");
		} else {
			// 2
			$(this.options.persistenceStatusSelector).removeClass("unsaved");
			$(this.options.persistenceStatusSelector).addClass("failed");
		}
	}

	_updateCursorPositionData(thisPad, changeType, processedText, changeText) {
		const offset = processedText.length;
		// Don't expect `0`
		switch (changeType) {
			case 1: // insertion
				if (offset <= thisPad.currentSelectionRange.start) {
					thisPad.currentSelectionRange.start += changeText.length;
					thisPad.currentSelectionRange.end += changeText.length;
				} else if (
					thisPad.currentSelectionRange.start <= offset &&
					offset < thisPad.currentSelectionRange.end
				) {
					thisPad.currentSelectionRange = undefined;
				}
				break;

			case -1: // deletion
				if (
					offset < thisPad.currentSelectionRange.start &&
					offset + changeText.length <= thisPad.currentSelectionRange.start
				) {
					thisPad.currentSelectionRange.start -= changeText.length;
					thisPad.currentSelectionRange.end -= changeText.length;
				} else if (
					(thisPad.currentSelectionRange.start <= offset &&
						offset < thisPad.currentSelectionRange.end) ||
					(offset <= thisPad.currentSelectionRange.start &&
						thisPad.currentSelectionRange.start < offset + changeText.length) ||
					(offset <= thisPad.currentSelectionRange.start &&
						thisPad.currentSelectionRange.end <= offset + changeText.length)
				) {
					thisPad.currentSelectionRange = undefined;
				}
				break;
		}
		// log("PAD currentSelectionRange: ", thisPad.currentSelectionRange);
	}

	/**
	 * wait for the right Faye channel to subscribe and inform other active pad users of own subscription
	 * named function to point the 'senaryon:subscribedFayeChannel' listener to, so that it can be called .off() in clearData()
	 */
	_handleFayeSubscriptionEvent(event, channel) {
		// log("PAD subscribed to channel Faye event TEST -- channel, own url:", channel, event.data.options.url);
		// don't do anything if this event is for another channel (trust that the event for this pad's channel is only triggered once)
		if (event.data.options.url != channel) {
			return;
		}

		debugLog(
			"PAD handling subscribed to channel Faye event -- channel:",
			channel,
		);

		// it is possible that the 'senaryon:subscribedFayeChannel' event is fired just before Faye is actually marked to be online, in which case below
		// `_sendViaFaye` method would throw an error, so give Faye 300ms to catch up
		const subscriptionHandleDelay =
			PrivatePub.fayeClient === null ||
			PrivatePub.fayeClient._dispatcher._state !=
				PrivatePub.fayeClient._dispatcher.UP ||
			PrivatePub.fayeClient._state != PrivatePub.fayeClient.CONNECTED
				? 300
				: 0;
		const thisPad = event.data;
		const currentVectors = [];

		thisPad.targets.forEach((target, index) => {
			currentVectors.push(target.state.vector.toString());
		});
		if (!thisPad.options.listenOnly) {
			thisPad.inputFieldsState = {
				enabled: true,
				printLog: false,
			};
		}

		if (subscriptionHandleDelay) {
			debugLog(
				"PAD set subscriptionHandleDelay because Faye client null OR client state, dispatcher state:",
				PrivatePub.fayeClient
					? PrivatePub.fayeClient._state +
							", " +
							PrivatePub.fayeClient._dispatcher._state
					: "null",
			);
		}

		setTimeout(() => {
			thisPad.fayeSubscriptionCallbacks.forEach((callback, index) => {
				callback(thisPad, currentVectors); // Only `_notifyOwnSubscription` needs the `currentVectors`
			});

			// give the other Pads a chance to handle their subscription events. `.off()` unsubscribes _all_
			// listeners that point to thisPad._handleFayeSubscriptionEvent, not just the one of this particular Pad
			setTimeout(() => {
				debugLog(
					"PAD removing listener for senaryon:subscribedFayeChannel from channel",
					channel,
				);
				$(document).off(
					"senaryon:subscribedFayeChannel",
					thisPad._handleFayeSubscriptionEvent,
				);
			}, 200);
		}, subscriptionHandleDelay);
	}

	_notifyOwnSubscription(pad, currentVectors) {
		pad._sendViaFaye({
			type: "subscribed",
			actorId: pad.actorId,
			currentVectors: currentVectors,
		});
	}

	_observePrivatePubChanges(oldval, newval, context) {
		// log("PAD into _observePrivatePubChanges -- old, new, own url", oldval, newval, context.options.url);
		if (
			[
				PrivatePub.SCRIPT_UNREACHABLE,
				PrivatePub.DISCONNECTING,
				PrivatePub.DISCONNECTED,
			].includes(newval)
		) {
			context.inputFieldsState = {
				enabled: false,
				printLog: true,
			};
		} else if (
			(oldval == PrivatePub.SCRIPT_UNREACHABLE &&
				newval == PrivatePub.SCRIPT_LOADED) ||
			(oldval == PrivatePub.DISCONNECTED && newval == PrivatePub.CONNECTED)
		) {
			context.inputFieldsState = {
				enabled: true,
				printLog: true,
			};
		}
	}

	_handleInputFieldStateChange(oldval, newval, context) {
		const printLog = newval.printLog;
		context[newval.enabled ? "_enableInputFields" : "_disableInputFields"](
			printLog,
		);
	}

	_disableInputFields(printLog) {
		printLog = printLog || false;
		if (printLog) {
			log(
				"PAD exceptionally disabling input fields -- own url",
				this.options.url,
			);
		}

		this.targets.forEach((target, index) => {
			target.elem.addClass("disabled").prop("disabled", true);
		});

		if (this.options.clearDataButtonSelector !== undefined) {
			$(this.options.clearDataButtonSelector)
				.addClass("disabled")
				.prop("disabled", true);
		}
	}

	_enableInputFields(printLog = false) {
		if (printLog) {
			log(
				"PAD exceptionally enabling input fields -- own url",
				this.options.url,
			);
		}

		this.targets.forEach((target, index) => {
			target.elem.removeClass("disabled").prop("disabled", false);
		});

		if (this.options.clearDataButtonSelector !== undefined) {
			const $clearDataButton = $(this.options.clearDataButtonSelector);
			if ($clearDataButton.data("wasInitiallyDisabled")) {
				$clearDataButton.removeData("wasInitiallyDisabled");
			} else {
				$clearDataButton.removeClass("disabled").prop("disabled", false);
			}
		}
	}

	/**
	 * named function to point the 'page:before-change' listener to, so that it can be called .off() in clearData()
	 */
	_handlePageBeforeChange(event) {
		event.data.clearData();
	}

	_handleError(errorMsg) {
		if (this.failedAt !== undefined) {
			return;
		}

		this.failedAt = new Date().toLocaleString();
		this.failReason = errorMsg;
		this._setPersistenceStatus(2);
		this.clearData();
	}

	_handledDestroyedElem(event) {
		log("PAD destroyed -- input fields length:", event.data.targets.length);
		event.data.clearData(); // clear data before deleting feed so that the subscription token is still present
		PrivatePub.deleteNonFeed(
			event.data.options.url,
			"pad input fields destroyed",
		);
	}

	/**
	 * checks if there are pending changes in any of the pads and updates rails, then clears the pad data and intervals
	 * should be called just before leaving a page with a pad or removing it from the DOM
	 */
	clearData() {
		log("PAD clearData -- for pad:", JSON.stringify(this.options));

		// remove listeners
		$(document).off("page:before-change", this._handlePageBeforeChange);
		// in case the channel was never subscribed (i.e. Faye is most likely down)
		$(document).off(
			"senaryon:subscribedFayeChannel",
			this._handleFayeSubscriptionEvent,
		);

		PrivatePub.unobserveChange(
			"state",
			this._observePrivatePubChanges,
			".options.url",
			this.options.url,
		);
		this.targets[0].elem.off("destroyed", this._handledDestroyedElem);

		// update rails one last time if necessary
		if (!this.options.listenOnly) {
			this.targets.forEach((target, index) => {
				// delete focus in and out event listeners
				target.elem.off(this.options.targetFocusInEvents.join(" "));
				target.elem.off(this.options.targetFocusOutEvents.join(" "));
			}, this);
			if (!this.options.dontUpdateRails && this._checkStatesForRails().length) {
				// log("PAD updating Rails before clearing data");
				// to make sure the server has the latest version
				// rely on the target states being updated (usually this shold be done via the `clearDataButtonSelector` listener)
				this._updateRails();
			}
		}

		if (this.options.subscribersSpanSelector !== undefined) {
			$(this.options.subscribersSpanSelector).html(""); // clear
		}

		// case when a mod unsubscribes from a Pad because the actor has just completed the pad's task (new html is pushed to mod then)
		if (
			this.options.displayActivityForUserId &&
			DisplayActivityToMods.activeSubscribersData[
				this.options.displayActivityForUserId
			]
		) {
			DisplayActivityToMods.hide(this);
		}

		if (typeof pp !== "undefined" && this.failedAt !== undefined) {
			// disable input fields by calling _disableInputFields (this will most likely already have happened)
			this.inputFieldsState = {
				enabled: false,
				printLog: true,
			};
			pp.notifications.display("error", I18n.t("private_pub.pad_error_msg"));

			// delete Faye subscription as well so that this pad won't listen to incoming data anymore
			PrivatePub.deleteNonFeed(this.options.url, "error in pad");
			let base = this;
			base.targets[0].elem.removeData("pad");
			base = null;
		} else {
			delete this;
			this.targets[0].elem.removeData("pad");
		}
	}
}

/**
 * Generic jQuery plugin instantiation method call logic
 *
 * Method options are stored via jQuery's data() method in the relevant element(s)
 * Notice, myActionMethod mustn't start with an underscore (_) as this is used to
 * indicate private methods on the PLUGIN class.
 */
$.fn[pluginName] = function (methodOrOptions) {
	// NB declaring the function with `=>` here makes `this` inaccessible
	if (!$(this).length) {
		return $(this);
	}

	// Use Senaryon's function if present
	if (typeof pp != "undefined") {
		addPageChangeListener = $.proxy(
			pp.pageChangeConfirm.addListeners,
			pp.pageChangeConfirm,
		);
		removePageChangeListener = $.proxy(
			pp.pageChangeConfirm.removeListeners,
			pp.pageChangeConfirm,
		);
		log = pp.log;
		debugLog = pp.fayeLog;
	}

	let elementsOrderedBySelectorOrder = [];
	let $firstSelecetedEl;
	let instance;

	if (methodOrOptions && methodOrOptions.respectSelectorOrder) {
		// Respect the order of selectors provided, i.e. attach the Pad to the first element of the first selector,
		// even if it is not the first element that would be found in the DOM if all selectors would be used at once
		// Trust that all elements will be destroyed if the first is.
		const parentContainer = this.prevObject || document;
		// Cut the prevObject (=parent container) seletor from `this.selector` so that it won't get applied inside below loop.
		// E.g. we don't want the selector `.Draft__form .Draft_form select`, where the `prevObject` has the selector `.Draft__form`
		if (this.prevObject) {
			this.selector = this.selector.replace(this.prevObject.selector, "");
		}
		this.selector.split(",").forEach((selector, index) => {
			const $elsOfSelector = $(parentContainer).find(selector);
			if ($elsOfSelector.length) {
				if (!$firstSelecetedEl) {
					$firstSelecetedEl = $elsOfSelector.first();
					instance = $firstSelecetedEl.data(pluginName);
				}
				$elsOfSelector.each((index, elOfSelector) => {
					elementsOrderedBySelectorOrder.push(elOfSelector);
					if (!$(elOfSelector).is($firstSelecetedEl)) {
						$(elOfSelector).data("pad-slave-for", $firstSelecetedEl);
					}
				});
			}
		});
		elementsOrderedBySelectorOrder = Array.prototype.concat.apply(
			[],
			elementsOrderedBySelectorOrder,
		);
	} else {
		elementsOrderedBySelectorOrder = this;
		$firstSelecetedEl = $(this).first();
	}

	if (instance) {
		// CASE: call for pad, only return the options
		if (typeof methodOrOptions === "undefined") {
			return instance.options;
		}
		// CASE: action method (public method on PLUGIN class)
		else if (typeof methodOrOptions == "string") {
			if (methodOrOptions.indexOf("_") != 0 && instance[methodOrOptions]) {
				return instance[methodOrOptions](
					Array.prototype.slice.call(arguments, 1),
				);
			}
			// CASE: invalid method
			else if (methodOrOptions.indexOf("_") == 0) {
				$.error("Method " + methodOrOptions + " is private!"); // all methods are public atm
			} else {
				$.error("Method " + methodOrOptions + " does not exist.");
			}
		} else if (typeof methodOrOptions == "object") {
			$.error(
				"Pad with id #" +
					$firstSelecetedEl.attr("id") +
					" already initialized!",
			);
		}
	}
	// CASE: argument is options object or empty = initialize
	else if (typeof methodOrOptions === "object") {
		instance = new Pad(elementsOrderedBySelectorOrder, methodOrOptions);
		// only attach pad to the first elements in the scope, trust that all elements will be destroyed if the first is
		$firstSelecetedEl.data(pluginName, instance);
		return this;
	}
	// CASE: method called before init
	else if (!instance) {
		$.error("Pad must be initialized before using method: " + methodOrOptions);
	}
};
